<template>
  <div class="d-flex flex-wrap w-100">
    <div
      v-for="(picture, $picIndex) in pictures"
      :key="picture.id"
      class="avatar-container p-2 mx-1"
      @click="openGallery($picIndex)"
    >
      <div class="avatar">
        <img v-if="picture.thumb" :src="picture.thumb" alt="" class="avatar-img rounded" />
        <img v-else :src="picture.url" alt="" class="avatar-img rounded" />

        <div class="layout">
          <button
            v-if="editSelectionIndex !== $picIndex && canEdit"
            title="Editar"
            class="btn btn-link mr-4 p-1 px-2"
            @click="selectToEdit($picIndex)"
          >
            <i class="fas fa-pen"></i>
          </button>
          <button
            v-if="editSelectionIndex !== $picIndex && canDelete"
            title="Eliminar"
            class="btn btn-link p-1 px-2 pl-2"
            @click="removalConfirmation($picIndex)"
          >
            <i class="fas fa-trash"></i>
          </button>
        </div>
      </div>

      <div v-if="editSelectionIndex !== $picIndex" class="pr-1 pl-1 mt-1 text-justify text-muted small">
        {{ picture.description }}
      </div>

      <div v-else class="d-flex flex-column">
        <el-input v-model="descriptionToEdit" name="description" placeholder="Description" value="picture.description">
        </el-input>
        <button class="w-100 mt-1 btn text-white btn-success btn-sm" @click="updatePicture">
          <i class="fas fa-save mr-1"></i>Guardar
        </button>
        <button class="w-100 mt-1 btn text-white btn-danger btn-sm" @click="resetEdition">
          <i class="fas fa-times mr-1"></i>Cancelar
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import swal from 'sweetalert2';

export default {
  props: {
    pictures: {
      type: Array,
      default: () => {
        return [];
      },
    },

    showGallery: {
      type: Boolean,
      default: false,
    },

    canDelete: {
      type: Boolean,
      default: false,
    },

    canEdit: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      images: [],
      visible: false,
      showingIndex: 0,
      editSelectionIndex: null,
      descriptionToEdit: null,
    };
  },

  methods: {
    resetEdition() {
      this.editSelectionIndex = null;
      this.descriptionToEdit = null;
    },

    updatePicture() {
      this.$emit('update-picture', {
        index: this.editSelectionIndex,
        data: { description: this.descriptionToEdit },
      });
    },

    removePicture(index) {
      this.$emit('remove-picture', index);
    },

    openGallery(index) {
      if (!this.pictures[index]) {
        return;
      }

      if (this.showGallery) {
        this.images = this.pictures.map((i) => i.url);
        this.showingIndex = index;
      }

      this.$emit('open-gallery', this.pictures[index].id);
    },

    removalConfirmation(index) {
      swal({
        title: 'Se eliminará la imagen',
        text: '¿Desea proceder?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sí, eliminar',
        buttonsStyling: false,
        confirmButtonClass: 'btn btn-danger',
        cancelButtonClass: 'btn btn-secondary',
        cancelButtonText: 'Cancelar',
      }).then((result) => {
        if (result.value) {
          this.removePicture(index);
        }
      });
    },

    selectToEdit(index) {
      this.editSelectionIndex = index;
      this.descriptionToEdit = this.pictures[index].description;
    },
  },
};
</script>

<style scoped>
.avatar-container {
  max-width: 170px !important;
}

.avatar {
  width: 150px;
  height: 150px;
  cursor: pointer;
}

.avatar img {
  object-fit: cover;
  width: 150px;
  height: 150px;
}

.layout {
  position: absolute;
  width: 150px;
  height: 150px;
}

.layout:hover {
  background: #2d2d2d55;
}

.layout button {
  color: white;
  position: absolute;
  top: 0;
  right: 0;
}

.layout button:hover {
  color: #f5365c;
}
</style>
